// extracted by mini-css-extract-plugin
export default {"container":"FlowInsightsHeader_container__3Q2mm","description":"FlowInsightsHeader_description__hwFw3"};